"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationNotificationType = exports.VerificationData = exports.VerificationNotificationMetadata = exports.VerificationNotificationContent = exports.VerificationNotification = void 0;
var enums_1 = require("./enums");
var VerificationNotification = /** @class */ (function () {
    function VerificationNotification() {
        this.applicationResponseId = '';
        this.applicationId = '';
        this.verificationType = enums_1.VerificationType.IdentityVerification;
        this.notificationType = VerificationNotificationType.VerificationApproved;
        this.suggestedContent = new VerificationNotificationContent();
        this.verificationData = new VerificationData();
        this.metadata = new VerificationNotificationMetadata();
    }
    return VerificationNotification;
}());
exports.VerificationNotification = VerificationNotification;
var VerificationNotificationContent = /** @class */ (function () {
    function VerificationNotificationContent() {
        this.title = '';
        this.message = '';
    }
    return VerificationNotificationContent;
}());
exports.VerificationNotificationContent = VerificationNotificationContent;
var VerificationNotificationMetadata = /** @class */ (function () {
    function VerificationNotificationMetadata() {
        this.verificationName = '';
        this.currentStatus = enums_1.IDIncomeVerificationStatus.InProgress;
        this.previousStatus = undefined;
        this.hasStatusChange = false;
    }
    return VerificationNotificationMetadata;
}());
exports.VerificationNotificationMetadata = VerificationNotificationMetadata;
var VerificationData = /** @class */ (function () {
    function VerificationData() {
        this.verificationType = enums_1.VerificationType.IdentityVerification;
        this.status = enums_1.IDIncomeVerificationStatus.InProgress;
        this.createdDate = new Date();
    }
    return VerificationData;
}());
exports.VerificationData = VerificationData;
var VerificationNotificationType;
(function (VerificationNotificationType) {
    VerificationNotificationType["VerificationApproved"] = "VerificationApproved";
    VerificationNotificationType["VerificationRejected"] = "VerificationRejected";
    VerificationNotificationType["VerificationReInitiated"] = "VerificationReInitiated";
})(VerificationNotificationType || (exports.VerificationNotificationType = VerificationNotificationType = {}));
